<template>
    <div class="header-intrebari">
        <div class="hero">
            <div class="background background--cover background--bottom hero__background">
                <div class="background__image lazyloaded">&nbsp;</div>
            </div>
            <div class="hero__band">
                <div class="hero__message">
                    <h1 class="heading heading--1 heading--light heading--leading hero__heading">Roaming</h1>
                </div>
            </div>
            <nav v-if="selectedCountry" class="breadcrumbs breadcrumbs--transparent">
                <div class="spring">
                    <ol class="breadcrumbs__list hidden-xs">
                        <li class="breadcrumbs__item">
                            <router-link :to="{ name: 'main' }">Home</router-link>
                            <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </li>
                        <li class="breadcrumbs__item">
                            <router-link :to="{ name: 'destinatie', params: { country: this.$route.params.country, service: offerType } }" v-html="selectedCountry.name"></router-link>
                            <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </li>
                        <li class="breadcrumbs__item">
                            <router-link :to="{ name: 'destinatie', params: { country: this.$route.params.country, service: offerType } }" v-html="offerTypeText"></router-link>
                            <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </li>
                        <li class="breadcrumbs__item">
                            <router-link :to="{ name: 'destinatie', params: { country: this.$route.params.country, service: offerType } }" v-html="travelTimeText"></router-link>
                            <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </li>
                        <li class="breadcrumbs__item">
                            <span v-html="tip.title" class="breadcrumbs__crumb breadcrumbs__crumb--current"></span>
                        </li>
                    </ol>
                    <ol class="breadcrumbs__list visible-xs">
                        <li class="breadcrumbs__item">
                            <router-link :to="{ name: 'destinatie', params: { country: this.$route.params.country, service: offerType } }">
                                <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                    <use xlink:href="#icon-chevron-right"></use>
                                </svg>
                            </router-link>
                            <router-link :to="{ name: 'destinatie', params: { country: this.$route.params.country, service: offerType } }" v-html="tip.title"></router-link>
                        </li>
                    </ol>
                </div>
            </nav>
        </div>
        <div v-if="selectedCountry" class="spring">
            <div class="section section--gallery bundle text-left">
                <h1 v-html="tip.title"></h1>
                <div class="grid text-center">
                    <div class="grid__item grid__item--3/4 grid__item--sm-1/1 pad20 text-left">
                        <div v-html="tip.content"></div>
                    </div>
                </div>
                <!-- <download-as-pdf></download-as-pdf> -->
                <br />
                <br />
                <feedback view="full"></feedback>
            </div>
        </div>
    </div>
</template>

<script>
import DownloadAsPdf from './DownloadAsPdf.vue';

export default {
    name: 'DetaliiTip',
    components: {
        DownloadAsPdf,
    },
    computed: {
        selectedCountry() {
            var urlCountry = this.$root.countries.find((country) => country.name === this.$route.params.country);
            return this.$root.selectedCountry || urlCountry;
        },

        travelTipsSpace() {
            var travelTipsSpace = 1;
            var offerType = 'postpaid';
            if (this.$route.offerType === 'Cartelă') {
                offerType = 'prepaid';
            } else if (this.$route.offerType === 'Internet') {
                offerType = 'internet';
            }
            if (!this.selectedCountry) travelTipsSpace = 1;
            else travelTipsSpace = this.selectedCountry[offerType] !== 1 ? 1 : 0;
            return this.$route.params.travelTipsSpace || travelTipsSpace;
        },

        offerType() {
            return this.$route.params.offerType;
        },

        offerTypeText() {
            var offerType = this.$route.params.offerType;
            return this.$root.services.find((service) => service.url === offerType).name_short;
        },

        travelTime() {
            return this.$route.params.travelTime;
        },

        travelTimeText() {
            var travelTime = this.$route.params.travelTime;
            return this.$root.travelTimes.find((item) => item.url === travelTime).name;
        },

        tip() {
            var tip = this.$route.params.tip;
            if (!tip) {
                tip = this.$root.travelTips[this.travelTipsSpace][this.offerType][this.travelTime].find((travelTip) => travelTip.name === this.$route.params.tipName);
            }
            return tip;
        },
    },
    watch: {
        $route(newRoute, oldRoute) {
            if (newRoute.params.country !== oldRoute.params.country) {
                this.getCountryFromURL();
            }
        },
    },
    methods: {
        getCountryFromURL: function () {
            var urlCountry = this.$root.countries.find((country) => country.nameClean === this.$route.params.country);
            this.$root.selectedCountry = urlCountry;
        },
    },
    mounted() {
        this.getCountryFromURL();
    },
};
</script>
